import { render, staticRenderFns } from "./RoomCalendarRegistration.vue?vue&type=template&id=838c7e60&scoped=true&"
import script from "./RoomCalendarRegistration.vue?vue&type=script&lang=js&"
export * from "./RoomCalendarRegistration.vue?vue&type=script&lang=js&"
import style0 from "./RoomCalendarRegistration.vue?vue&type=style&index=0&id=838c7e60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838c7e60",
  null
  
)

export default component.exports